import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {isMobile} from 'react-device-detect';

import {singleBottomMPUProps} from "modules/Common/components/GptProperties";
import config from 'config';
import GptAdvert from 'modules/Common/components/GptAdvert';
import AdvertWrapper from 'modules/Common/components/AdvertWrapper';

import GreyhoundRacingFastResult from './GreyhoundRacingFastResult';

export default class GreyhoundRacingFastResultsList extends Component {

  static propTypes = {
    isMobileFn: PropTypes.func,
    fastResults: PropTypes.shape({
      fastResults: PropTypes.arrayOf(PropTypes.shape({
        race_reference: PropTypes.shape({
          id: PropTypes.number.isRequired
        }).isRequired
      })).isRequired
    })
  };

  render() {
    const {
      isMobileFn = () => isMobile,
      fastResults: {fastResults: fastResultsList = []} = {}
    } = this.props;

    const isMobileSize = isMobileFn();
    const initialFastResults = isMobileSize ? fastResultsList.slice(0, 3) : fastResultsList;
    const finalFastResults = isMobileSize ? fastResultsList.slice(3) : [];

    return (
      <div className="fast-results">
        <h1 className="page-main-title">Fast Results</h1>
        <AdvertWrapper ocSlot={["greyhounds", "leaderboard"]} additionalProperties={{view: "greyhounds", location: "/greyhounds"}} />
        {initialFastResults.length > 0 ?
          <div className="fast-results-list initial-fast-results">
            {initialFastResults.map(fastResult => (
              <GreyhoundRacingFastResult key={fastResult.race_reference.id} data={fastResult}/>
            ))}
          </div>
        :
          <div className="no-fast-results">No fast results.</div>
        }
        {isMobileSize &&
        <GptAdvert
          ocDetails={{
            ocSlot: ["greyhounds", "mpu"]
          }}
          performDetails={singleBottomMPUProps}
        />
        }
        {finalFastResults.length > 0 &&
        <div className="fast-results-list remaining-fast-results">
          {finalFastResults.map(fastResult => (
            <GreyhoundRacingFastResult key={fastResult.race_reference.id} data={fastResult}/>
          ))}
        </div>
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/GreyhoundRacing/components/GreyhoundRacingFastResultsList.js